import {
	FiveDaysNotificationIcon,
	FlowNotSignedNotificationIcon,
	NewFlowNotificationIcon,
	FlowSignedNotificationIcon,
	MonthStartingNotificationIcon,
	FifteenDaysNotificationIcon,
} from 'assets/icons';

export const REGEX_PASSWORD = /^(?=.*[A-Z])(?=.*[!#@$%&])(?=.*[0-9])(?=.*[a-z]).{8,}$/;

export const NOT_NUMBERS = /\D+$/;

export const CPF_REGEX =
	/([0-9]{2}[.][0-9]{3}[.][0-9]{3}[/][0-9]{4}[-][0-9]{2})|([0-9]{3}[.][0-9]{3}[.][0-9]{3}[-][0-9]{2})/g;

export const DATE_REGEX = /[0-9]{2}[/][0-9]{2}[/][0-9]{4}/g;

export const PHONE_MASK = '(99)99999-9999';

export const CPF_MASK = '999.999.999-99';

export const CPF_MASK_REGEX = /(\d{3})(\d{3})(\d{3})(\d{2})/g;

export const CEP_MASK = '99999-999';

export const CNPJ_MASK = '99.999.999/9999-99';

export const CEP_REGEX = /^([0-9]{5})([0-9]{3})$/g;

export const DATE_MASK = '99/99/9999';

export const ONLY_NUMBERS_REGEX = /[^\d]/gi;

export const ONLY_NUMBERS_AND_COMMA_REGEX = /[^\d,]+/g;

export const THOUSAND_REGEX = /\B(?=(\d{3})+(?!\d))/g;

export const TOTAL_PERCENTAGE = 100;

export const PHONE_REGEX = /\(?(\d{2})\)?(\d{5})-?(\d{4})/g;

export const EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_MASK_REGEX = /^(.)(.*)(.@.*)$/;

export const AUTH_MANAGER_KEYS = {
	TOKEN: '@SellerPerformance:token',
	REFRESH_TOKEN: '@SellerPerformance:refreshToken',
	USER: '@SellerPerformance:user',
	LAST_PATIENT_VIEWED: '@SellerPerformance:lastPatientViwed',
	SESSION_LOG: '@SellerPerformance:sessionLog',
};

export const STATUS_CODE = {
	Unauthorized: 401,
};

export const GET_CODE_METHOD = {
	PASTE: 'PASTE',
	QRCODE: 'QRCODE',
};

export const PHONE_CONTACT = {
	label: '4000-1406',
	whatsapp: '+5503140001406',
	phone: '03140001406',
};

export const REMOVE_PONCTUATION = /[.,-/#!$%^&*;:{}=\-_`~()@+?><[\]+]/g;

export const TIME_TO_REDIRECT = 2000; // 2 segundos para enviar para o login

export const DATE_FORMAT = 'dd/MM/yyyy';

export const MONTH_YEAR_FORMAT = 'MM/yyyy';

export const DATE_HOUR_FORMAT = 'dd/MM/yyyy HH:mm';

export const EMPTY_ZIPCODE = 'N/A';

export const PHONE_NUMBER_LENGHT = 11;

export const FORM_GENERIC_ERROR = 'Alguns campos não foram preenchidos corretamente, verifique e tente novamente.';

export const STATUS = [
	{ label: 'Ativo', value: true },
	{ label: 'Inativo', value: false },
];

export const ACCESS_LEVELS = {
	administrator: {
		label: 'Administrador',
		value: 'administrator',
	},
	general_manager: {
		label: 'Gerente Geral',
		value: 'general_manager',
	},
	new_manager: {
		label: 'Gestor Novo',
		value: 'new_manager',
	},
	new_seller: {
		label: 'Vendedor Novo',
		value: 'new_seller',
	},
	preowned_manager: {
		label: 'Gestor Seminovo',
		value: 'preowned_manager',
	},
	preowned_seller: {
		label: 'Vendedor Seminovo',
		value: 'preowned_seller',
	},
};

export const ACCESS_LEVELS_ENUM = {
	ADMINISTRATOR: 'administrator', //Administrador
	GENERAL_MANAGER: 'general_manager', //Gerente Geral
	NEW_MANAGER: 'new_manager', //Gestor Novo
	PREOWNED_MANAGER: 'preowned_manager', //Gestor Seminovo
	NEW_SELLER: 'new_seller', //Vendedor Novo
	PREOWNED_SELLER: 'preowned_seller', //Vendedor Seminovo
};

export const MONTHS = [
	{
		label: 'Janeiro',
		value: 1,
	},
	{
		label: 'Fevereiro',
		value: 2,
	},
	{
		label: 'Março',
		value: 3,
	},
	{
		label: 'Abril',
		value: 4,
	},
	{
		label: 'Maio',
		value: 5,
	},
	{
		label: 'Junho',
		value: 6,
	},
	{
		label: 'Julho',
		value: 7,
	},
	{
		label: 'Agosto',
		value: 8,
	},
	{
		label: 'Setembro',
		value: 9,
	},
	{
		label: 'Outubro',
		value: 10,
	},
	{
		label: 'Novembro',
		value: 11,
	},
	{
		label: 'Dezembro',
		value: 12,
	},
];

export const PERIODS = [
	{
		label: 'Últimos doze meses',
		value: 12,
	},
	{
		label: 'Últimos onze meses',
		value: 11,
	},
	{
		label: 'Últimos dez meses',
		value: 10,
	},
	{
		label: 'Últimos nove meses',
		value: 9,
	},
	{
		label: 'Últimos oito meses',
		value: 8,
	},
	{
		label: 'Último sete meses',
		value: 7,
	},
	{
		label: 'Últimos seis meses',
		value: 6,
	},
	{
		label: 'Últimos cinco meses',
		value: 5,
	},
	{
		label: 'Últimos quatro meses',
		value: 4,
	},
	{
		label: 'Últimos três meses',
		value: 3,
	},
	{
		label: 'Últimos dois meses',
		value: 2,
	},
	{
		label: 'Último mês',
		value: 1,
	},
];

export const img64Exemplo =
	'data:image/jpeg;base64,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';

export const SEGMENT_TABLE: Record<string, string> = {
	fluxoLojaPassante: 'Fluxo de Loja (Passantes)',
	fluxoLigacoes: 'Fluxo de Ligaçoes Recebidas',
	comparecimentoLigacoes: 'Comparecimento Ligações',
	fluxoLojaVendedor: 'Fluxo Loja Vendedor',
	ligacoesRecebidas: 'Ligações Recebidas',
	comparecimento: 'Comparecimento',
	conversion: 'Conversão',
	totalSales: 'VENDAS TOTAL',
	billings: 'Faturamento',
	averageTicket: 'Ticket Médio',
	complimentaryExpenses: 'Despesas com Cortesias',
	percentageMb: '% M.B',
	financing: 'FINANCIAMENTO',
	financingContracts: 'Contratos Financiamento',
	financingPenetration: 'Penetracion Financiamento',
	financingEvasion: 'Financiamento fora',
	financingValuePenetration: 'Penetration Valor Financiado',
	carReturn: 'Retorno por Carro',
	financingProfitability: 'Rentabilidade Financiamento',
	tccb: 'TCCB',
	tccbByContract: 'TCCB por Contrato',
	tccbByCar: 'TCCB por Carro',
	placement: 'Emplacamento',
	placementByCar: 'Emplacamento por carro',
	capture: 'Captação',
	evaluation: 'Avaliação',
	txEvaluation: 'Taxa avaliação',
	txPurchase: 'Taxa compra',
	txCapture: 'Taxa captura',
	contributionMargin: 'Margem de contribuição',
	contributionMargin2: 'Lucro Bruto Total',
	contributionMargin3: '(%) Lucro Bruto s/Faturamento',
	accessoriesSale: 'Acessórios',
	averageTicketAccessories: 'Ticket Médio Acessorios',
	hgsi: 'HGSI',
	nps: 'NPS',
	oficina: 'Oficina',
	leads: 'Leads',
};

export const SEGMENT_TYPE_STRING = [
	'fluxoLojaPassante',
	'fluxoLigacoes',
	'comparecimentoLigacoes',
	'fluxoLojaVendedor',
	'ligacoesRecebidas',
	'comparecimento',
	'totalSales',
	'financingContracts',
	'placementByCar',
	'capture',
	'evaluation',
	'nps',
	'oficina',
	'leads',
];

export const SEGMENT_TYPE_PERCENTAGE = [
	'conversion',
	'percentageMb',
	'financingPenetration',
	'financingEvasion',
	'financingValuePenetration',
	'financingProfitability',
	'tccb',
	'placement',
	'txEvaluation',
	'txPurchase',
	'txCapture',
	'accessoriesSale',
	'averageTicketAccessories',
	'contributionMargin3',
	'hgsi',
];

export const SEGMENT_TYPE_CURRENCY = [
	'billings',
	'averageTicket',
	'complimentaryExpenses',
	'financing',
	'carReturn',
	'tccbByContract',
	'tccbByCar',
	'contributionMargin',
	'contributionMargin2',
];

export const INDICATOR_TO_SEGMENT: Record<string, string> = {
	average_ticket: 'averageTicket', // 'Ticket Medio'
	billings: 'billings', // 'Faturamento'
	capture: 'capture', // 'Captação'
	car_return: 'carReturn', // 'Retorno por Carro'
	comparecimento: 'comparecimento', // 'Comparecimento'
	complimentary_expenses: 'complimentaryExpenses', // 'Despesas com Cortesias'
	contribution_margin: 'contributionMargin', // 'Margem de Contribuição'
	contribution_margin_2: 'contributionMargin2', // 'Margem de Contribuição'
	contribution_margin_3: 'contributionMargin3', // 'Margem de Contribuição'
	evaluation: 'evaluation', // 'Avaliação'
	financing: 'financing', // 'Financiamento'
	financing_contracts: 'financingContracts', // 'Contratos Financiamento'
	financing_evasion: 'financingEvasion', // 'Evasão Financiamento'
	financing_penetration: 'financingPenetration', // 'Penetracion Financiamento'
	financing_profitability: 'financingProfitability', // 'Rentabilidade Financiamento'
	financing_value_penetration: 'financingPenetration', // 'Penetracion Valor Financiado'
	fluxo_loja_vendedor: 'fluxoLojaVendedor', // 'Fluxo Loja Vendedor'
	ligacoes_recebidas: 'ligacoesRecebidas', // 'Ligações Recebidas'
	percentage_mb: 'percentageMb', // '% M.B'
	placement: 'placement', // 'Emplacamento'
	placement_by_car: 'placementByCar', // 'Emplacamento por Carro'
	tccb: 'tccb', // 'TCCB'
	tccb_by_car: 'tccbByCar', // 'TCCB por Carro'
	tccb_by_contract: 'tccbByContract', // 'TCCB por Contrato'
	total_sales: 'totalSales', // 'Vendas Total'
};

export const DEPARTMENTS_OPTIONS = [
	{
		label: 'Veículos novos',
		value: 'new',
	},
	{
		label: 'Veículos seminovos',
		value: 'preowned',
	},
	{
		label: 'Venda direta',
		value: 'direct_sale',
	},
	{ label: 'Repasse', value: 'resale' },
];

export const DEPARTMENT_OPTION_LABEL_TO_ACCESS_LEVELS = {
	'Veículos novos': 'new_seller',
	'Veículos seminovos': 'preowned_seller',
	'Venda direta': 'direct_sale',
	Repasse: 'resale',
};

export const DEPARTMENT_OPTION_VALUE_TO_ACCESS_LEVELS = {
	new: 'new_seller',
	preowned: 'preowned_seller',
	direct_sale: 'direct_sale',
	resale: 'ressale',
};

export const NEW_DEPARTMENT_OPTION_VALUE_TO_ACCESS_LEVELS = {
	new: 'new',
	preowned: 'preowned',
	direct_sale: 'direct_sale',
	resale: 'ressale',
};

export const DEPARTMENT_ACCESS_LEVELS_TO_PARAMS = {
	new: 'Veículos novos',
	preowned: 'Veículos seminovos',
	direct_sale: 'Venda direta',
	resale: 'Repasse',
};

export const DEPARTMENT_OPTION_PARAMS = {
	'Veículos novos': 'new',
	'Veículos seminovos': 'preowned',
	'Venda direta': 'direct_sale',
	Repasse: 'resale',
};

export const DEPARTMENT_ACCESS_LEVELS_EMPLOYEE_FILTER = {
	new: 'new_seller',
	preowned: 'preowned_seller',
	direct_sale: 'new_seller',
	resale: 'preowned_seller',
};

export const ORDER_BY_COMPANY = 'company__company';

export const NOTIFICATION_ICONS = {
	month_starting: <MonthStartingNotificationIcon />,
	fifteen_days_month: <FifteenDaysNotificationIcon />,
	five_days_month: <FiveDaysNotificationIcon />,
	new_flow: <NewFlowNotificationIcon />,
	flow_signed: <FlowSignedNotificationIcon />,
	flow_not_signed_daily: <FlowNotSignedNotificationIcon />,
	flow_not_signed_manager: <FlowNotSignedNotificationIcon />,
};

export const FLOW_ERROR_TYPES = {
	passingShopFlow: 'Fluxo de loja passante:', //FLUXO LOJA PASSANTE
	shopSellers: 'Vendedores loja:', //VENDEDORES LOJA
	customerServiceQuantity: 'Qtd. atendimento:', //QUANTIDADE ATENDIMENTOS
	incomingCalls: 'Ligações recebidas:', //LIGAÇÕES RECEBIDAS
	attendance: 'Comparecimento:', //COMPARECIMENTO
	prospection: 'Prospecção:', //PROSPECÇÃO
	conversionOnFlow: 'Conversão em fluxo:', //CONVERSÃO EM FLUXO
	leads: 'Leads:', //LEADS
	customerWorkshop: 'Cliente oficina:', //CLIENTE OFICINA
	conversionEvaluation: 'Conversão avaliação:', //CONVERSÃO AVALIAÇÃO
	quantity: 'Qtd. atendimento:', //QUANTIDADE
	averageTicket: 'Ticket médio:', //TICKET MEDIO
	margin: 'Margem:', //MARGEM
	validGift: 'Brindes válidos veículo:', //BRINDE VALIDO
	unitGrossMargin: 'Margem bruta unidade:', //MARGEM BRUTA UNIDADE
	totalMargin: 'Margens total:', //MARGEM TOTAL
	financing: 'Financiamento:', //FINANCIAMENTO
	penetrationAmount: 'Penetration - qtde:', //QUANTIDADE PENETRATION
	financedAmount: 'Valor financiado:', //VALOR FINANCIADO
	rApplied: '“R” Aplicado:', //R APLICADO
	averageContractRevenue: 'Receita média/contrato:',
	financingIncome: 'Receita financiamento:',
	contracts: 'Contratos:', //CONTRATOS
	averageContractValue: 'Valor por contrato:', //VALOR MEDIO CONTRATO
	revenueTccb: 'Receita T.C.C.B.:', //RECEITA TCCB
	averageSaleValue: 'Valor médio de venda:', //VALOR MEDIO VENDA
	averageValueCost: 'Valor médio de custo:', //VALOR MEDIO CUSTO
	profitDocument: 'Lucro por documento:', //LUCRO DOCUMENTO
	averageCarRevenue: 'Receita média/carro:', //RECEITA MEDIA CARRO
	dispatcherRevenue: 'Receita despachante:', //RECEITA DESPACHANTE
	unitSales: 'Vendas por unidade:', //VENDAS POR UNIDADE
	saleAccessories: 'Venda acessórios:', //VENDA ACESSORIOS
	assessmentRate: 'Taxa de avaliação:', //TAXA DE AVALIACAO
	reviewsAmount: 'Qtde de avaliações:', //QUANTIDADE AVALIACOES
	fundingRate: 'Taxa de captação:', //TAXA CAPTACAO
	totalCatch: 'Total captura:', //TOTAL CAPTURA
	captureAward: 'Premiação por captura:', //PREMIACAO CAPTURA
	totalSalary: 'Valor total:', //VALOR TOTAL SALARIO
	commissionOnSale: 'Comis. sobre venda:', //COMISSAO SOBRE VENDA
	comissionOnMargin: 'Comis. sobre margem:', //COMISSAO SOBRE MARGEM
	financingCommission: 'Comis. financiamento:', //COMISSAO FINANCIAMENTO
	forwardingCommission: 'Comis. despachante:', //COMISSAO DESPACHANTE
	tccbCommission: 'Comissão T.C.C.B.:', //COMISSAO TCCB
	saleValue: 'Valor venda:', //VALOR VENDA
	quantitySale: 'Quantidade venda:', //QUANTIDADE VENDA
	fundingAward: 'Prêmio financiamento:', //PREMIO FINANCIAMENTO
	dispatcherAward: 'Prêmio despachante:', //PREMIO DESPACHANTE
	tccbAward: 'Prêmio T.C.C.B.:', //PREMIO TCCB
	dsr: 'DSR:', //DSR
	calendarDays: 'Dias de calendário:', //DIAS CALENDARIO
	sundayHolidays: 'Domingos e feriados:', //DOMINGOS FERIADOS
};

export const NISA_PARAMETERS = {
	fluxoLojaPassante: 'Fluxo de Loja (Passantes)',
	fluxoLigacoes: 'Fluxo de Ligaçoes Recebidas',
	comparecimentoLigacoes: 'Comparecimento Ligações',
	fluxoLojaVendedor: 'Fluxo Loja Vendedor',
	ligacoesRecebidas: 'Ligações Recebidas',
	comparecimento: 'Comparecimento',
	conversao: 'Conversão',
	totalSales: 'Vendas Total',
	billings: 'Faturamento',
	averageTicket: 'Ticket Médio',
	complimentaryExpenses: 'Despesas com Cortesias',
	percentageMb: '% M.B',
	financing: 'Financiamento',
	financingContracts: 'Contratos Financiamento',
	financingPenetration: 'Penetracion Financiamento',
	financingEvasion: 'Financiamento fora',
	financingValuePenetration: 'Penetration Valor Financiado',
	carReturn: 'Retorno por Carro',
	financingProfitability: 'Rentabilidade Financiamento',
	tccb: 'TCCB',
	tccbByContract: 'TCCB por Contrato',
	tccbByCar: 'TCCB por Carro',
	placement: 'Emplacamento',
	placementByCar: 'Emplacamento por carro',
	capture: 'Captação',
	evaluation: 'Avaliação',
	txEvaluation: 'Taxa avaliação',
	txBuy: 'Taxa compra',
	txCapture: 'Taxa captura',
	contributionMargin: 'Margem de contribuição',
	totalGrossProfit: 'Lucro Bruto Total',
	grossProfitwithoutRevenue: '(%) Lucro Bruto s/Faturamento',
	accessories: 'Acessórios',
	mediumAccessoryTicket: 'Ticket Médio Acessorios',
	hgsi: 'HGSI',
	nps: 'NPS',
	oficina: 'Oficina',
	leads: 'Leads',
};

export const BRAZILIAN_STATES = [
	{ label: 'AC', value: 'AC' },
	{ label: 'AL', value: 'AL' },
	{ label: 'AP', value: 'AP' },
	{ label: 'AM', value: 'AM' },
	{ label: 'BA', value: 'BA' },
	{ label: 'CE', value: 'CE' },
	{ label: 'DF', value: 'DF' },
	{ label: 'ES', value: 'ES' },
	{ label: 'GO', value: 'GO' },
	{ label: 'MA', value: 'MA' },
	{ label: 'MT', value: 'MT' },
	{ label: 'MS', value: 'MS' },
	{ label: 'MG', value: 'MG' },
	{ label: 'PA', value: 'PA' },
	{ label: 'PB', value: 'PB' },
	{ label: 'PR', value: 'PR' },
	{ label: 'PE', value: 'PE' },
	{ label: 'PI', value: 'PI' },
	{ label: 'RJ', value: 'RJ' },
	{ label: 'RN', value: 'RN' },
	{ label: 'RS', value: 'RS' },
	{ label: 'RO', value: 'RO' },
	{ label: 'RR', value: 'RR' },
	{ label: 'SC', value: 'SC' },
	{ label: 'SP', value: 'SP' },
	{ label: 'SE', value: 'SE' },
	{ label: 'TO', value: 'TO' },
];
